import * as React from 'react'

// Components
import Svg from './..'

const Lock = props => {
  return (
    <Svg viewBox='0 0 20 21' fill='none' {...props}>
      <circle cx={10} cy={10.5} r={10} fill='#F3EFF1' />
      <circle
        cx={10}
        cy={10.5}
        r={9.405}
        stroke='#000'
        strokeOpacity={0.04}
        strokeWidth={1.189}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.932 13.142c.533 0 .941-.431.941-.964a.925.925 0 00-.941-.941.925.925 0 00-.941.941c0 .533.408.964.941.964zm2.392-5.25v.964h.465c.533 0 .964.397.964.93v4.784c0 .533-.431.93-.964.93H7.075c-.533 0-.964-.397-.964-.93V9.786c0-.533.43-.93.964-.93h.465v-.964A2.371 2.371 0 019.932 5.5a2.371 2.371 0 012.392 2.392zM9.932 6.464c-.805 0-1.429.623-1.429 1.428v.964h2.857v-.964c0-.805-.623-1.428-1.428-1.428z'
        fill='#FF9545'
      />
    </Svg>
  )
}

export default Lock
